import { render } from "./HeroiconsOutlineChartBar.vue?vue&type=template&id=9b0593da"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChartBar.vue"]])

export default __exports__